module.exports = __webpack_public_path__ + "media/images/pag-right-black-8b9360d7a227a0ea7dc71fb154238f67.png";